module.exports = "../../static/img/es.d6693ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/flags/es.png
// module id = 927
// module chunks = 2